import AbstractRequestTask from '../AbstractRequestTask';
import Launcher from '../../apa/Launcher';
import DeviceStorage from '../../../components/DeviceStorage/DeviceStorage';

class SuperHighlightTask extends AbstractRequestTask {
    constructor() {
        super();
    }

    getMethod() {
        return 'GET';
    }


    getParams() {
        const params = super.getParams();
        const user_id = DeviceStorage.getItem('user_id');
        const paramsTask = {
          authpn: params.authpn,
          authpt: params.authpt,
          device_type: params.device_type,
          device_model: params.device_model,
          device_category: params.device_category,
          device_manufacturer: params.device_manufacturer,
          device_id: params.device_id,
          device_so: params.device_so,
          user_id,
          device_name: params.device_name,
          user_token: params.user_token
      }
 
      if(!user_id || user_id === ''){
        delete paramsTask.user_id;
      }
        return paramsTask;
    }

    getUrl() {
        const http = 'https://';
        const url = Launcher.get('akamai_mfwk');
        return `${http}${url}/services/user/v1/superhighlight`;
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowModal() {
      return false;
    }
}

export default SuperHighlightTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/SuperHighlightTask.js